var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',{staticClass:"name"},[_vm._v("Tieyong Zeng")]),_c('p',{staticClass:"lang-switch",on:{"click":_vm.changeLang}},[_vm._v(_vm._s(_vm.lang === 'zh' ? 'English' : '中文'))])])}
var staticRenderFns = []

export { render, staticRenderFns }